import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { DataItemType } from "@cloudpivot/form/schema";
import SelectUser from "./select-user.vue";
import { Checkbox } from "@h3/antd-vue";
let ImportSheet = class ImportSheet extends Vue {
    constructor() {
        super(...arguments);
        this.tableWidth = "";
        this.DataItemType = DataItemType;
        this.errType = {
            Repeat: 1,
            NoExisted: 2,
            Null: 3,
            DisableDept: 4,
        };
    }
    get tableData() {
        let data = [];
        data = this.dataSource.map((d, index) => {
            d.key = index + 1;
            d.index = index + 1;
            return d;
        });
        return data;
    }
    mounted() {
        this.$nextTick(() => {
            this.calcTableWidth();
        });
    }
    /*
     * 计算Table宽度
     */
    calcTableWidth() {
        let tableWidth = 0;
        const tableWrapWidth = document.querySelector(".import-sheet-container")
            ? document.querySelector(".import-sheet-container").clientWidth
            : 0;
        this.columns.forEach((c) => {
            // 子表宽度由内部数据项决定
            if (c.propertyType === DataItemType.Sheet &&
                Array.isArray(c.childColumns)) {
                c.childColumns.forEach((child) => {
                    tableWidth += child.width;
                });
                if (c.childColumns.length) {
                    tableWidth += 1;
                }
            }
            else {
                tableWidth += c.width;
            }
        });
        this.tableWidth = tableWidth > tableWrapWidth ? `${tableWidth}px` : "100%";
    }
    getNameAndErrorText(name, type) {
        let errCode = "";
        switch (type) {
            case this.errType.Repeat:
                errCode = `${this.$t("cloudpivot.list.pc.repeat")}`;
                break;
            case this.errType.NoExisted:
                errCode = `${this.$t("cloudpivot.list.pc.noExisted")}`;
                break;
            case this.errType.Null:
                errCode = `${this.$t("cloudpivot.list.pc.null")}`;
                break;
            case this.errType.DisableDept:
                errCode = `${this.$t("cloudpivot.list.pc.deptDisable")}`;
                break;
        }
        return `${name ? name : ""}${errCode}`;
    }
    checkboxChange(val, index) {
        this.$set(this.tableData[index], "checked", val.target.checked);
        if (!val.target.checked) {
            //找到所有子表
            const arr = this.columns.filter((c) => c.propertyType === DataItemType.Sheet);
            //清空当前数据中子表的选中状态
            const dataArr = this.tableData[index];
            arr.forEach((a) => {
                dataArr[a.key].forEach((s) => {
                    this.$set(s, "checked", val.target.checked);
                });
            });
        }
    }
    childCheckboxChange(val, code, pidx, index) {
        const source = this.tableData[pidx];
        const sheetArr = source[code];
        //改变当前复选框状态
        this.$set(sheetArr[index], "checked", val.target.checked);
        //判断其他子表中是否在当前的这条数据中有选中状态
        const arr = this.columns.filter((c) => c.propertyType === DataItemType.Sheet && c.key !== code);
        let hasChecked = false;
        arr.forEach((a) => {
            hasChecked = !!source[a.key].find((s) => s.checked);
        });
        if (!hasChecked) {
            //改变对应当前这条数据复选框状态
            source.checked = !!sheetArr.find((s) => s.checked);
        }
    }
    getAllChecked() {
        return this.tableData.every((c) => c.checked);
    }
    getAllChildChecked(code) {
        //改变全选的状态
        let checkArr = [];
        this.tableData.forEach((t) => {
            checkArr = checkArr.concat(t[code]);
        });
        return checkArr.every((c) => c.checked);
    }
    checkAll(val) {
        this.tableData.map((t) => {
            this.$set(t, "checked", val.target.checked);
        });
        if (!val.target.checked) {
            //找到所有子表
            const arr = this.columns.filter((c) => c.propertyType === DataItemType.Sheet);
            //清空所有子表的选中状态
            this.tableData.forEach((t) => {
                arr.forEach((a) => {
                    t[a.key].forEach((s) => {
                        this.$set(s, "checked", val.target.checked);
                    });
                });
            });
        }
    }
    childCheckAll(val, code) {
        //判断子表中是否在当前的这条数据中有选中状态
        const arr = this.columns.filter((c) => c.propertyType === DataItemType.Sheet);
        //改变当前子表项与所有数据复选框状态
        this.tableData.map((t, index) => {
            this.$set(t, "checked", val.target.checked);
            t[code].forEach((s) => {
                this.$set(s, "checked", val.target.checked);
            });
            // 若有子表中有选中的则不清空当前数据的选中状态
            arr.forEach((a) => {
                !t.checked && (t.checked = !!t[a.key].find((s) => s.checked));
            });
        });
    }
};
tslib_1.__decorate([
    Prop({ default: true })
], ImportSheet.prototype, "fixedHead", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], ImportSheet.prototype, "fixedLeft", void 0);
tslib_1.__decorate([
    Prop()
], ImportSheet.prototype, "columns", void 0);
tslib_1.__decorate([
    Prop()
], ImportSheet.prototype, "dataSource", void 0);
ImportSheet = tslib_1.__decorate([
    Component({
        name: "import-sheet",
        components: {
            SelectUser,
            ACheckbox: Checkbox,
        },
    })
], ImportSheet);
export default ImportSheet;
